import { useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { addErrorToast } from '../../../components/errors/toast/ToastUtils';
import { useIntl } from 'react-intl';
import {
  NotificationAction,
  doActionNotification as doActionNotificationService,
} from '../../../services/notification/NotificationService';

interface Values {
  isLoading: boolean;
  doActionNotification: (notificationAction: NotificationAction) => Promise<boolean>;
}

const useDoActionNotification = (): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const intl = useIntl();

  const doActionNotification = async (notificationAction: NotificationAction): Promise<boolean> => {
    try {
      setIsLoading(true);
      const result = await doActionNotificationService(notificationAction);
      if (result.data) {
        setIsLoading(false);
        return true;
      } else {
        setIsLoading(false);
        addErrorToast({ message: intl.formatMessage({ id: 'errors.generic' }) });
        return false;
      }
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      return false;
    }
  };

  return { doActionNotification, isLoading };
};

export default useDoActionNotification;
